import NavBar from '@/next/components/NavBar/NavBar';

export default NavBar;
